import React, { useEffect, useState, lazy } from 'react';
import { ZapIcon, EyeIcon, AlertCircleIcon } from 'lucide-react';
import { trackPurchaseClick, trackSectionView, trackContentEngagement } from './MetaPixelTracker';
export function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [viewerCount] = useState(234); // Static count to prevent layout shifts
  const slides = [{
    type: 'image',
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nvWm3U6eoasauCrd6zLCpd/imagen_1.png',
    alt: 'ImpulseX Product'
  }, {
    type: 'image',
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3KXWUBGJGJcHR4LgzMnsoD/Generated_Image_September_18%2C_2025_-_3_22PM.png',
    alt: 'ImpulseX Bottle with Red and Gold Smoke'
  }, {
    type: 'image',
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9egNYiBVNghwwmPcDbf1Vo/Generated_Image_September_18%2C_2025_-_3_32PM.png',
    alt: 'Man holding ImpulseX product'
  }];
  useEffect(() => {
    // Track section view when component mounts
    trackSectionView('Hero');
    // Auto-rotate carousel every 5 seconds
    const interval = setInterval(() => {
      setCurrentSlide(prev => prev === slides.length - 1 ? 0 : prev + 1);
    }, 5000);
    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);
  // Manual slide control
  const handleNextSlide = () => {
    setCurrentSlide(prev => prev === slides.length - 1 ? 0 : prev + 1);
    trackContentEngagement('carousel', 'product_carousel', 'next');
  };
  const handlePrevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? slides.length - 1 : prev - 1);
    trackContentEngagement('carousel', 'product_carousel', 'prev');
  };
  return <section className="pt-0 pb-16 border-b border-gray-800" data-id="element-170">
      <div className="text-center mb-8" data-id="element-171">
        <div className="bg-red-600 text-white text-xs font-bold py-1.5 px-3 rounded-full shadow-sm flex items-center justify-center border border-red-700 mx-auto w-fit hover:bg-red-700 transition-colors" data-id="element-172">
          <AlertCircleIcon className="h-3 w-3 text-white mr-1.5" data-id="element-173" />
          <span data-id="element-174">¡ÚLTIMAS 10 UNIDADES DISPONIBLES!</span>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold mb-6 mt-6 bg-gradient-to-r from-red-500 to-orange-500 text-transparent bg-clip-text flex items-center justify-center" data-id="element-175">
          <ZapIcon className="h-8 w-8 md:h-10 md:w-10 text-red-500 mr-2" data-id="element-176" />{' '}
          IMPULSEX 30ML
        </h1>
        <p className="text-xl text-gray-400" data-id="element-177">Activación Masculina Natural</p>
        <div className="flex items-center justify-center mt-2 text-sm text-gray-300 bg-gray-900/50 py-1 px-3 rounded-full mx-auto w-fit" data-id="element-178">
          <EyeIcon className="h-4 w-4 text-red-500 mr-2" data-id="element-179" />
          <span data-id="element-180">
            Más de <span className="font-bold text-red-500" data-id="element-181">{viewerCount}</span>{' '}
            personas están viendo este producto ahora
          </span>
        </div>
      </div>
      <div className="max-w-3xl mx-auto" data-id="element-182">
        <h2 className="text-3xl font-bold mb-6 text-left" data-id="element-183">
          ¿Y si te dijera que el verdadero poder… no se traga, se activa?
        </h2>
        <p className="text-xl mb-6 text-left" data-id="element-184">
          Una gota. No una cápsula. No una excusa. Una activación. Porque hay
          algo que pocos se atreven a decir…
        </p>
        <div className="space-y-4 mb-10" data-id="element-185">
          <div className="flex items-start" data-id="element-186">
            <span className="inline-flex items-center justify-center w-6 h-6 mr-2" data-id="element-187">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-500" data-id="element-188">
                <path d="M20 14c0.34 0 0.67 0.04 1 0.09V2l-8 5-8-5v17l8 5 6.45-4.03" data-id="element-189"></path>
                <path d="M3.3 7L12 12l8.7-5" data-id="element-190"></path>
              </svg>
            </span>
            <p className="text-lg" data-id="element-191">El deseo no se compra.</p>
          </div>
          <div className="flex items-start" data-id="element-192">
            <span className="inline-flex items-center justify-center w-6 h-6 mr-2" data-id="element-193">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-500" data-id="element-194">
                <path d="M20 14c0.34 0 0.67 0.04 1 0.09V2l-8 5-8-5v17l8 5 6.45-4.03" data-id="element-195"></path>
                <path d="M3.3 7L12 12l8.7-5" data-id="element-196"></path>
              </svg>
            </span>
            <p className="text-lg" data-id="element-197">La energía no se finge.</p>
          </div>
          <div className="flex items-start" data-id="element-198">
            <span className="inline-flex items-center justify-center w-6 h-6 mr-2" data-id="element-199">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-500" data-id="element-200">
                <path d="M20 14c0.34 0 0.67 0.04 1 0.09V2l-8 5-8-5v17l8 5 6.45-4.03" data-id="element-201"></path>
                <path d="M3.3 7L12 12l8.7-5" data-id="element-202"></path>
              </svg>
            </span>
            <p className="text-lg" data-id="element-203">
              Y el rendimiento… no se pierde, se despierta.
            </p>
          </div>
          <div className="mt-6" data-id="element-204">
            <div className="relative w-full max-w-md mx-auto rounded-lg shadow-lg overflow-hidden" style={{
            aspectRatio: '1/1',
            height: '300px'
          }} data-id="element-205">
              {slides.map((slide, index) => <div key={index} className={`transition-opacity duration-500 absolute inset-0 ${currentSlide === index ? 'opacity-100 z-10' : 'opacity-0 z-0'}`} style={{
              height: '100%'
            }} onClick={() => trackContentEngagement('image', `product_image_${index + 1}`, 'click')} data-id="element-206">
                  <img src={slide.src} alt={slide.alt} className="w-full h-full object-cover rounded-lg" loading={index === 0 ? 'eager' : 'lazy'} onError={e => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = 'https://placehold.co/300x300/black/red?text=ImpulseX';
              }} data-id="element-207" />
                </div>)}
              <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2 z-20" data-id="element-208">
                {slides.map((_, index) => <button key={index} onClick={() => {
                setCurrentSlide(index);
                trackContentEngagement('carousel', 'product_carousel', `slide_${index + 1}`);
              }} className={`w-3 h-3 rounded-full transition-all ${currentSlide === index ? 'bg-white scale-110' : 'bg-gray-400 opacity-70'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-209" />)}
              </div>
              <button onClick={handlePrevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full z-20 transition-colors" aria-label="Previous slide" data-id="element-210">
                ←
              </button>
              <button onClick={handleNextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full z-20 transition-colors" aria-label="Next slide" data-id="element-211">
                →
              </button>
            </div>
            <div className="flex justify-center mt-4" data-id="element-212"></div>
            <div className="flex justify-center my-6" data-id="element-213">
              <div className="w-3/4 border-t border-gray-700" data-id="element-214"></div>
            </div>
            <div className="flex justify-center" data-id="element-215">
              <div className="text-red-500 font-bold text-xl py-3 px-5 text-center cursor-default border border-red-500/30 bg-black/80 rounded-lg max-w-md mx-auto italic" onClick={() => trackContentEngagement('message', 'provocative_message', 'view')} data-id="element-216">
                ¿Quiere convertirte en un actor de brazzer con tu mujer?
              </div>
            </div>
            <div className="flex justify-center mt-3 mb-4" data-id="element-217">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ewHxXWcbTrLTj4fRGo4c8E/brazzers-logo-11.png" alt="Brazzers Logo" className="h-12 shadow-lg rounded" loading="lazy" onClick={() => trackContentEngagement('image', 'brazzers_logo', 'click')} onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = 'https://placehold.co/120x40/black/red?text=Brazzers';
            }} data-id="element-218" />
            </div>
            <div className="max-w-lg mx-auto text-sm text-gray-200 bg-gray-900/70 p-6 rounded-lg shadow-lg my-6 border border-red-600/30" data-id="element-219">
              <p className="mb-2 font-medium" data-id="element-220">Imaginá esto…</p>
              <p className="mb-2" data-id="element-221">
                Luz baja. Tus dedos recorriéndola lento. Ella muerde la
                almohada. Y vos — más firme que nunca. No es magia. Es
                activación.
              </p>
              <p className="mb-2" data-id="element-222">
                La mirás. Ella gira la cabeza… y te dice en voz baja: "¿Qué te
                hiciste? Hoy estás diferente…"
              </p>
              <p className="mb-2" data-id="element-223">
                Y mientras imaginás esa escena… tu cuerpo ya empezó a activarse.
              </p>
              <p className="mb-3" data-id="element-224">
                <span className="inline-flex items-center" data-id="element-225">
                  <span className="inline-block w-4 h-4 mr-1" data-id="element-226">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-500" data-id="element-227">
                      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3s.5-1.5 1-2.5V5c0-1.25-.5-2-1.5-2s-1.5 1-1.5 2v.5M15 5c0-1-.5-2-1.5-2-.97 0-1.5 1-1.5 2 0 .5.5 2 1.5 3s1.5 2.5 1.5 4a2.5 2.5 0 0 1-5 0" data-id="element-228" />
                    </svg>
                  </span>
                  Más potencia.
                </span>
                <span className="inline-flex items-center ml-2" data-id="element-229">
                  <span className="inline-block w-4 h-4 mr-1" data-id="element-230">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-500" data-id="element-231">
                      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3s.5-1.5 1-2.5V5c0-1.25-.5-2-1.5-2s-1.5 1-1.5 2v.5M15 5c0-1-.5-2-1.5-2-.97 0-1.5 1-1.5 2 0 .5.5 2 1.5 3s1.5 2.5 1.5 4a2.5 2.5 0 0 1-5 0" data-id="element-232" />
                    </svg>
                  </span>
                  Más aguante.
                </span>
                <span className="inline-flex items-center ml-2" data-id="element-233">
                  <span className="inline-block w-4 h-4 mr-1" data-id="element-234">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-500" data-id="element-235">
                      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3s.5-1.5 1-2.5V5c0-1.25-.5-2-1.5-2s-1.5 1-1.5 2v.5M15 5c0-1-.5-2-1.5-2-.97 0-1.5 1-1.5 2 0 .5.5 2 1.5 3s1.5 2.5 1.5 4a2.5 2.5 0 0 1-5 0" data-id="element-236" />
                    </svg>
                  </span>
                  Más deseo natural.
                </span>
                <span className="inline-flex items-center ml-2" data-id="element-237">
                  <span className="inline-block w-4 h-4 mr-1" data-id="element-238">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-500" data-id="element-239">
                      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3s.5-1.5 1-2.5V5c0-1.25-.5-2-1.5-2s-1.5 1-1.5 2v.5M15 5c0-1-.5-2-1.5-2-.97 0-1.5 1-1.5 2 0 .5.5 2 1.5 3s1.5 2.5 1.5 4a2.5 2.5 0 0 1-5 0" data-id="element-240" />
                    </svg>
                  </span>
                  Y esa mirada tuya… que ahora la vuelve loca.
                </span>
              </p>
              <p className="mb-2" data-id="element-241">
                Mientras leés esto… ya sabés que lo querés. Imaginate estar tan
                encendido… que ella no pueda dejar de buscarte. No una vez. No
                por compromiso. Sino por puro instinto animal.
              </p>
              <p className="mb-2" data-id="element-242">ImpulseX no solo te activa… te transforma.</p>
              <p data-id="element-243">
                Y cuando lo pruebes… vas a entender por qué hay hombres que no
                pueden estar sin él.
              </p>
            </div>
            <div className="flex justify-center mt-8 mb-6" data-id="element-244">
              <a href="#" className="group flex items-center gap-2 bg-black border border-red-500 hover:bg-red-500/10 text-white font-medium py-3 px-6 rounded-lg transition-all duration-300 shadow-lg" onClick={e => {
              e.preventDefault();
              trackContentEngagement('navigation', 'testimonios_button', 'click');
              // Scroll to testimonials section using the ID
              const testimonialsSection = document.getElementById('testimonials-section');
              if (testimonialsSection) {
                testimonialsSection.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }} data-id="element-245">
                Ver testimonios
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-500 group-hover:translate-y-1 transition-transform duration-300" data-id="element-246">
                  <path d="M12 5v14M5 12l7 7 7-7" data-id="element-247" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-3" data-id="element-248">
          <a href="https://impulseexar.myshopify.com/cart/46748096954596:1" onClick={() => trackPurchaseClick('Hero_Beele_Button')} data-id="element-249"></a>
        </div>
        <div className="flex justify-center mt-6 mb-8" data-id="element-250">
          <div className="rounded-lg overflow-hidden shadow-lg border border-gray-700 max-w-sm" data-id="element-251"></div>
        </div>
        <div className="flex justify-center" data-id="element-252"></div>
      </div>
    </section>;
}